<template>
  <ag-card-container
    :title="$t('multiproject.menu.main')"
    :search.sync="search"
    fluid
  >
    <template #extension>
      <v-tabs :slider-size="0" slider-color="accent" grow>
        <v-tab
          to="/multiproject/versions"
          exact
          @click="search = ''"
          v-text="$t('multiproject.menu.versions')"
        />
        <v-tab
          to="/multiproject/draws"
          @click="search = ''"
          v-text="$t('multiproject.menu.draws')"
        />
      </v-tabs>
    </template>
    <router-view :search="search" />
  </ag-card-container>
</template>

<script>
import AgCardContainer from 'src/components/common/AgCardContainer'

export default {
  name: 'MultiprojectContainer',
  components: {
    AgCardContainer,
  },
  beforeRouteEnter (to, from, next) {
    return to.name === 'MultiprojectMain'
      ? next({ name: 'MultiprojectVersionList' })
      : next()
  },
  beforeRouteUpdate (to, from, next) {
    return to.name === 'MultiprojectMain'
      ? next({ name: 'MultiprojectVersionList' })
      : next()
  },
  data: () => ({
    search: '',
  }),
}
</script>

<style lang="scss" scoped>
.v-tab {
  &::before {
    opacity: 0.4 !important;
  }

  &:hover::before {
    opacity: 0.1 !important;
  }
}

.v-tab--active {
  &::before {
    opacity: 0.1 !important;
  }

  &:hover::before {
    opacity: 0.1 !important;
  }
}
</style>
